import videojs from 'video.js';

//import 'MEDIASITE/Server/Player/Player/Javascript/Scripts/babelfish.js'; // imports BabelFish to window.BabelFish

// Bundle and register all Video.js languages
function importAll(r) {
    r.keys().forEach(r);
}

importAll(require.context('video.js/dist/lang/', true, /\.js$/));

const LocalizedDictionary = window.SiteData?.LocalizedDictionary ?? window.LocalizedStrings ?? [];
const Culture = (window.SiteData ?? window.ApplicationData?.SiteData)?.Culture;

// Set up BabelFish.js for SOFO-specific translations
/*const babelFish = new window.BabelFish({
    dictionary: LocalizedDictionary
});*/

// Add SOFO translations into Video.js
videojs.addLanguage(Culture, Object.fromEntries(LocalizedDictionary.map(item => {
    return [item.text, item.translation];
})));

/**
 * 
 * @param {...any} args
 * @returns {string}
 */
/*export function translate(...args) {
    return babelFish.translate(...args);
}*/

/**
 * @returns {string}
 */
export function getCurrentLanguage() {
    //return Culture?.split('-')?.[0] ?? 'en';
    return Culture;
}

const replaceRegex = /%%\d*%%/;
export function replacePlaceholders(templateString, ...rest) {
    return rest.reduce((previous, current) => (
        previous.replace(replaceRegex, current)
    ), templateString);
}